import HttpClient from './base/http-client';
import { IUser } from '../context/current-user';
import MCPMarketEnvironmentDetection, {
  MCP_MARKET_ENVIRONMENT_COUNTRY_CODES,
} from '../utils/market-environment-detection';

export interface IClientResponse {
  restaurant: IUser;
}

class RestaurantApiService extends HttpClient {
  constructor(baseURL: string, authHeaderName: string) {
    super(baseURL, authHeaderName);
  }

  public getRestaurantData = (token: any): Promise<IUser[]> => {
    return this.instance.get('/restaurants', {
      headers: {
        'X-Auth': `Bearer ${token}`,
      },
    });
  };
}

const getBaseUrl = () => {
  const { countryCode } = MCPMarketEnvironmentDetection.getMarketEnvironment();
  if (countryCode === MCP_MARKET_ENVIRONMENT_COUNTRY_CODES.UK) {
    return process.env.AUTH_API_URL_EU_WEST as string;
  }
  return process.env.AUTH_API_URL_EU_CENTRAL as string;
};

export default new RestaurantApiService(getBaseUrl(), 'X-Auth');
